import React from 'react';

import PropTypes from 'prop-types';

import EntityPickerModalLoadMoreButton from './EntityPickerModalLoadMoreButton';
import EntityPickerModalLoadMoreError from './EntityPickerModalLoadMoreError';
import EntityPickerModalLoadMoreLoader from './EntityPickerModalLoadMoreLoader';
import { entityShape, pluginShape } from '../helpers/propTypes';

const EntityPickerModalListContent = ({
  onLoadMore,
  selectedIds,
  disabledIds,
  multiple,
  entities,
  loading,
  error,
  onTryAgain,
  onChange,
  setSelection,
  disabled,
  filters,
  plugin,
  isPluginDisabledInEntitlements: _isPluginDisabledInEntitlements,
}) => {
  const showLoader = plugin && loading;
  const showError = plugin && error && !showLoader;
  const LoadMoreButton =
    plugin.CustomPickerLoadMoreButton || EntityPickerModalLoadMoreButton;
  const LoadMoreLoader =
    plugin.CustomPickerLoadMoreLoader || EntityPickerModalLoadMoreLoader;
  const LoadMoreError =
    plugin.CustomPickerLoadMoreError || EntityPickerModalLoadMoreError;

  return (
    <div>
      <div>
        {entities.map((entity) => {
          const { EntityPickerItem } = plugin;
          return (
            <EntityPickerItem
              key={entity.id}
              entity={entity}
              multiple={multiple}
              onChange={
                multiple
                  ? (checked) => onChange({ entity, checked })
                  : () => setSelection([entity])
              }
              disabled={disabled || disabledIds.includes(entity.id)}
              selected={selectedIds.includes(entity.id)}
              filters={filters}
            />
          );
        })}
      </div>
      {onLoadMore && !showLoader && !showError && (
        <LoadMoreButton onLoadMore={onLoadMore} />
      )}
      {showLoader && <LoadMoreLoader />}
      {showError && <LoadMoreError onTryAgain={onTryAgain} />}
    </div>
  );
};

EntityPickerModalListContent.propTypes = {
  /**
   * Whether we're loading something from BE.
   */
  loading: PropTypes.bool,
  /**
   * Whether had error fetching data from BE.
   */
  error: PropTypes.bool,
  /**
   * Callback to fetch data again.
   */
  onTryAgain: PropTypes.func,
  /**
   * Load the next page of entities.
   */
  onLoadMore: PropTypes.func,
  /**
   * IDs of selected entities.
   */
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  /**
   * IDs of entities we want to mark as disabled.
   */
  disabledIds: PropTypes.arrayOf(PropTypes.string),
  /**
   * Whether the component is multi selectable.
   */
  multiple: PropTypes.bool,
  /**
   * List of entities.
   */
  entities: PropTypes.arrayOf(entityShape).isRequired,
  /**
   * Callback to handle selection change.
   * Handler is of shape: ({entity, checked}) => *
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Callback to set Selections.
   * Handler is of shape: (selectedNodes) => *
   */
  setSelection: PropTypes.func.isRequired,
  /**
   * Whether we're currently in saving process.
   */
  disabled: PropTypes.bool,
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
  /**
   * The plugin to use for selected entity type.
   */
  plugin: pluginShape,
  /**
   * Whether the plugin is disabled in entitlements.
   */
  isPluginDisabledInEntitlements: PropTypes.bool,
};

export default EntityPickerModalListContent;
